import React from 'react'
import { Link } from "react-router-dom"
import Menu from './Menu';

const MegaMenu = ({ rule, index }) => {
    const megaMenu = rule.ContentRuleZone?.[0];
    console.log("menu", megaMenu)
    return (
        <li className="nav-item dropdown">
            {console.log("megaMenu-link",megaMenu?.attributes?.link)}
            {console.log("megaMenu-link-length",megaMenu && megaMenu.contents && megaMenu.contents.ContentFolderZone && megaMenu.contents.ContentFolderZone.length)}
            <Link className={`nav-link ${megaMenu && megaMenu.contents && megaMenu.contents.ContentFolderZone && megaMenu.contents.ContentFolderZone.length > 0 ? "dropdown-toggle" : ""} `} to={megaMenu?.attributes?.link ? megaMenu.attributes.link : '#'} id={`navbarScrollingDropdown${index}`}
                role={megaMenu?.attributes?.link ? "" : "button"}
                data-bs-toggle={megaMenu?.attributes?.link ? "" : "dropdown"}
                aria-expanded={megaMenu?.attributes?.link ? "" : "false"}>
                {megaMenu?.attributes?.displayName ? megaMenu.attributes.displayName : ''}
            </Link>
            {
                megaMenu?.contents?.ContentFolderZone?.[0]?.childRules &&
                <ul className="dropdown-menu dropdown-menu-right" aria-labelledby={`navbarScrollingDropdown${index}`}>
                    {megaMenu?.contents?.ContentFolderZone?.[0]?.childRules ? megaMenu.contents.ContentFolderZone[0].childRules.map((rule, index) => {
                        return <Menu key={index} rule={rule} index={index} />
                    }) : <></>}
                </ul>
            }
        </li>
    )
}

export default MegaMenu